import { render, staticRenderFns } from "./StatsBonusTips.vue?vue&type=template&id=3cb36462&"
import script from "./StatsBonusTips.vue?vue&type=script&lang=js&"
export * from "./StatsBonusTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports